<template>
  <div
     class="nuttrema-menu-list-item"
    :class="[`theme-${theme}`]"
    :style="styleProps"
    @click="$emit('click')">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'nuttrema-menu-list-item',
  props: {
    label: {
      type: String,
      required: false,
      default: null,
    },
    theme: {
      type: String,
      required: false,
      default: 'default',
    },
    styleProps: {
      type: Object,
      required: false,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~styles/theme/colors";

  .nuttrema-menu-list-item {
    display: flex;
    flex-shrink: 0;
    text-align: left;
    align-self: stretch;

    .list-item-label {
      font-size: 0.75em;
      color: $gray-light;
      margin-bottom: 0.5em;
      letter-spacing: 0.1em;
      text-transform: uppercase;
    }

    // &.theme-default {
    //   .list-item-link {
    //     flex-grow: 1;
    //     display: flex;
    //     padding: 0 0.5em;
    //     font-weight: 500;
    //     line-height: 1.15;
    //     font-size: 0.95em;
    //     margin-bottom: 0.5em;
    //     &:hover, &:focus, &:active {
    //       text-decoration: underline;
    //       color: inherit;
    //     }
    //   }
    // }


    &.theme-brand-image {
      span {
        padding: 0;
        display: flex;
        margin: 0.5em 0;
        align-items: center;
        justify-content: center;
        img {
          width: 80%;
        }
      }
    }

    &.theme-sidebar-menu {
      > /deep/ span {
        margin-bottom: 0.15em;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/navigation/nuttrema-menu-list-item.vue